import { useCallback, useMemo } from "react";
import styled from "styled-components";
import { Checkmark, Spinner } from "@sablier/v2-components/atoms";
import { _ } from "@sablier/v2-mixins";
import { useModalTransaction } from "~/client/hooks";

const Wrapper = styled.div`
  ${(props) => props.theme.styles.column}
  & {
    flex-shrink: 0;
    align-items: center;
    width: 100%;
    height: 180px;
    margin-bottom: calc(${(props) => props.theme.sizes.edge} * 4);
  }
`;

const Container = styled.div`
  ${(props) => props.theme.styles.row}
  & {
    position: relative;
    justify-content: center;
    width: 100%;
    height: 100%;
    max-width: 180px;
    max-height: 180px;
    & > * {
      position: absolute;
    }
  }
`;

function Visuals() {
  const { data } = useModalTransaction();

  const status = useMemo(() => data.status, [data.status]);

  const Asset = useCallback(() => {
    switch (status) {
      case "fail":
        return <Checkmark purpose={"fail"} />;
      case "success":
        return <Checkmark purpose={"success"} />;
      case "confirm":
      case "loading":
      case "sign":
      case "verify":
        return <Spinner size={160} thickness={3} color={"gray200"} />;
      default:
        return false;
    }
  }, [status]);

  return (
    <Wrapper data-status={status}>
      <Container>
        <Asset />
      </Container>
    </Wrapper>
  );
}

export default Visuals;
